import React from 'react';

const Footer = () => (
  <footer style={{ padding: '1rem', textAlign: 'center', backgroundColor: '#333', color: 'white' }}>
    <p>HEXRD © 2024 | Open Source Community Project</p>
  </footer>
);

export default Footer;
